import { Modal, DatePickerField, SelectField } from 'components';
import Button from 'components/Button';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { FC, useState, useEffect, useCallback } from 'react';
import { arrowLeft } from 'assets';

import SectionStyled, { HeaderStyle } from './styled';

interface Props {}

const ModalEditCheckInTime: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [startHour, setStartHour] = useState<string>('00');
  const [endHour, setEndHour] = useState<string>('01');
  const [startMinute, setStartMinute] = useState<string>('');
  const [endMinutes, setEndMinutes] = useState<string>('');
  const [messError, setMessError] = useState<string>('');
  const [checkSubmit, setCheckSubmit] = useState<boolean>(true);
  const checkMinute = useCallback(() => {
    if (startHour === endHour) {
      if (Number(startMinute) >= Number(endMinutes)) {
        setMessError('退場時刻は入場時刻以降の時刻を入力してください');
        setCheckSubmit(false);
      }
      if (Number(startMinute) < Number(endMinutes)) {
        setMessError('');
        setCheckSubmit(true);
      }
    } else {
      if (startHour > endHour) {
        setMessError('');
        setCheckSubmit(false);
      } else {
        setMessError('');
        setCheckSubmit(true);
      }
    }
  }, [endHour, startHour, startMinute, endMinutes]);

  useEffect(() => {
    checkMinute();
  }, [checkMinute]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      console.log(values);
      setVisible(false);
    },
  });

  return (
    <>
      <button onClick={() => setVisible(true)}>Open modal ModalEditCheckInTime</button>
      <Modal title={<Header />} visible={visible} footer={false} width={560}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-item">
                  <Form.Item
                    className="input-onsite"
                    label="作業員名"
                    colon={false}
                    name="employeeName"
                  >
                    <div className="siteName">{employeeName}</div>
                  </Form.Item>
                </div>
                <div className="box-item">
                  <Form.Item className="input-onsite" label="現場名" colon={false} name="siteName">
                    <div className="siteName">{siteName}</div>
                  </Form.Item>
                </div>
                <div className="box-item">
                  <Form.Item className="input-onsite" label="日付" colon={false} name="date">
                    <DatePickerField name="date" className="select-date" placeholder="" />
                  </Form.Item>
                </div>
                <div className="box-select-time">
                  <Form.Item
                    className="input-time"
                    label="入退場時刻"
                    colon={false}
                    name="startHour"
                  >
                    <SelectField
                      suffixIcon={<i className="triangle-down" />}
                      data={hours}
                      className="select-time"
                      name="startHour"
                      onChange={(value) => {
                        setStartHour(value);
                      }}
                    />
                    <div className="center-text">:</div>
                    <SelectField
                      suffixIcon={<i className="triangle-down" />}
                      data={minutes}
                      className="select-time"
                      name="startMinute"
                      onChange={(value) => {
                        setStartMinute(value);
                      }}
                    />
                  </Form.Item>
                  <div className="center-text-separate">〜</div>
                  <Form.Item className="input-time" label={<span />} name="endHour">
                    <div className="custom-mess-error">
                      <div className="custom-mess-error-2">
                        <SelectField
                          suffixIcon={<i className="triangle-down" />}
                          data={hours}
                          className="select-time"
                          name="endHour"
                          onChange={(value) => {
                            setEndHour(value);
                          }}
                        />
                        <div className="center-text">:</div>
                        <SelectField
                          suffixIcon={<i className="triangle-down" />}
                          data={minutes}
                          className="select-time"
                          name="endMinute"
                          onChange={(value) => setEndMinutes(value)}
                        />
                      </div>
                      <div className="mess-error">{messError}</div>
                    </div>
                  </Form.Item>
                </div>
              </div>
              <div className="ant-modal-footer">
                <Button className="button-secondary" onClick={() => setVisible(false)}>
                  キャンセル
                </Button>
                <ButtonSubmit disabled={!(formik.isValid && checkSubmit)}>確定</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

export default ModalEditCheckInTime;

const employeeName = '内田敏夫';
const siteName = '東京内田中様集合住宅新築工事';

const hours = Array.from({ length: 24 }, (x, i) =>
  i < 10 ? { label: `0${i}`, value: `0${i}` } : { label: `${i}`, value: `${i}` }
);

const minutes = Array.from({ length: 60 }, (x, i) =>
  i < 10 ? { label: `0${i}`, value: `0${i}` } : { label: `${i}`, value: `${i}` }
);
const initialValues = {
  date: '',
  startHour: '',
  startMinute: '',
  endHour: '',
  endMinute: '',
};

const validationSchema = yup.object().shape({
  date: yup.string().nullable().required(),
  startHour: yup.string().nullable().required(),
  startMinute: yup.string().nullable().required(),
  endHour: yup
    .date()
    .when('startHour', (startHour, schema) => {
      return (
        startHour && schema.min(Number(startHour), '退場時刻は入場時刻以降の時刻を入力してください')
      );
    })
    .nullable()
    .required(),
  endMinute: yup.string().nullable().required(),
});

const Header: FC = () => {
  return (
    <HeaderStyle>
      <img src={arrowLeft} alt="" />
      <div>入退場時刻補正</div>
    </HeaderStyle>
  );
};
